import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {RATING_COLOR, RATING_LABEL, fmtMs, fmtCls} from "./ratings";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

/** 1 ô metric với màu viền trái theo rating. */
function Metric({label, value, rating, hint}) {
	const color = RATING_COLOR[rating] || RATING_COLOR.na;

	return (
		<div className={cn('metric')} style={{borderLeftColor: color}}>
			<div className={cn('metric-label')}>{label}</div>
			<div className={cn('metric-value')} style={{color}}>{value}</div>
			<div className={cn('metric-rating')}>{hint || RATING_LABEL[rating] || ''}</div>
		</div>
	);
}

/**
 * Core Web Vitals + metric Lighthouse.
 * - Lab (lighthouseResult): LUÔN có.
 * - Field/CrUX: optional — site nhỏ không có → hiện thông báo.
 *
 * strat: {lab:{lcp,cls,tbt,fcp,si}, field:{available,lcp,inp,cls,fcp}}.
 */
function CoreWebVitals({strat = {}}) {
	const lab = strat.lab || {};
	const field = strat.field || {};

	return (
		<div className={cn('cwv')}>
			{/* Field data (CrUX) — dữ liệu người dùng thật. */}
			<div className={cn('cwv-block')}>
				<div className={cn('cwv-head')}>
					<FontAwesomeIcon icon="fa-light fa-users" /> Dữ liệu người dùng thật (CrUX)
				</div>

				{field.available ? (
					<div className={cn('metric-grid')}>
						<Metric label="LCP" value={fmtMs(field.lcp?.value)} rating={field.lcp?.rating} />
						<Metric label="INP" value={fmtMs(field.inp?.value)} rating={field.inp?.rating} />
						<Metric label="CLS" value={fmtCls(field.cls?.value)} rating={field.cls?.rating} />
						<Metric label="FCP" value={fmtMs(field.fcp?.value)} rating={field.fcp?.rating} />
					</div>
				) : (
					<div className={cn('cwv-empty')}>
						<FontAwesomeIcon icon="fa-light fa-circle-info" /> Chưa đủ lượng truy cập thực tế
						để Google cung cấp dữ liệu trường (CrUX) cho URL này.
					</div>
				)}
			</div>

			{/* Lab data (Lighthouse) — luôn có. */}
			<div className={cn('cwv-block')}>
				<div className={cn('cwv-head')}>
					<FontAwesomeIcon icon="fa-light fa-flask" /> Dữ liệu phòng thí nghiệm (Lab)
				</div>
				<div className={cn('metric-grid')}>
					<Metric label="LCP" value={fmtMs(lab.lcp?.value)} rating={lab.lcp?.rating} hint={lab.lcp?.display} />
					<Metric label="CLS" value={fmtCls(lab.cls?.value)} rating={lab.cls?.rating} hint={lab.cls?.display} />
					<Metric label="TBT" value={fmtMs(lab.tbt?.value)} rating={lab.tbt?.rating} hint={lab.tbt?.display} />
					<Metric label="FCP" value={fmtMs(lab.fcp?.value)} rating={lab.fcp?.rating} hint={lab.fcp?.display} />
					<Metric label="Speed Index" value={fmtMs(lab.si?.value)} rating={lab.si?.rating} hint={lab.si?.display} />
				</div>
			</div>
		</div>
	);
}

export default CoreWebVitals;
